module.exports = __webpack_public_path__ + "img/ad_placeholder@2x.be7a36ea.png";